"use strict";

registerModule('panels');

const slideDuration = 500;

onLoad(() => {
    // Initialize the slide-up and -down stuff.
    document.querySelectorAll('.toggle-parent')
        .forEach(item => setupToggleHandlers(item));
});

/**
 * Sets up the event handling for a section-toggle.
 * @param {HTMLElement} parent
 */
export function setupToggleHandlers(parent) {
    const trigger = parent.querySelector('.toggle-trigger'),
        target  = parent.querySelector('.toggle-target');

    trigger.addEventListener('click', toggle);
    trigger.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
            toggle();
        }
    });

    function toggle() {
        if (parent.classList.contains('closed')) {
            if (openPanel(target)) {
                parent.classList.replace('closed', 'opened');
                parent.dispatchEvent(new CustomEvent('opened', { bubbles: true }));
            }
        } else {
            if (closePanel(target)) {
                parent.classList.replace('opened', 'closed');
                parent.dispatchEvent(new CustomEvent('closed', { bubbles: true }));
            }
        }
    }
}

/**
 * Slides a HTML element 'open'.
 *
 * This only works when there's no horizontal padding or margin!
 * @param {HTMLElement} element
 * @returns {boolean}
 */
export function openPanel(element) {
    // can't do nothin' when it's locked!
    if (element.dataset.locked) {
        return false;
    }

    element.dataset.locked = '1';

    const height = element.scrollHeight;

    element.style.height = height + 'px';
    element.style.overflow = 'hidden';
    element.classList.remove('slide-in', 'closed');
    element.classList.add('slide-out');

    setTimeout(() => {
        element.style.height = null;
        element.style.overflow = null;
        element.dataset.locked = '';
        element.classList.remove('slide-out');
        element.classList.add('opened');
    }, slideDuration);

    return true;
}

/**
 * Slides an HTML element 'closed'.
 *
 * This only works when there's no horizontal padding or margin!
 * @param {HTMLElement} element
 * @returns {boolean}
 */
export function closePanel(element) {
    // can't do nothin' when it's locked!
    if (element.dataset.locked) {
        return false;
    }

    element.dataset.locked = '1';

    const height = element.scrollHeight;

    element.style.height = height + 'px';
    element.classList.remove('slide-out', 'opened');
    element.classList.add('slide-in');

    setTimeout(() => {
        element.style.height = '0px';
        element.style.overflow = 'hidden';
        element.dataset.locked = '';
        element.classList.remove('slide-in');
        element.classList.add('closed');
    }, slideDuration);

    return true;
}
